import styled from 'styled-components';
import device from 'utils/device';

export const Box = styled.div`
  overflow: auto;
  max-height: 100%;
  height: 100%;
  max-width: 100%;
  width: 100%;

  @media ${device.tablet} {
    /* padding-right: 10px; */
    /* padding-bottom: 10px; */
  }

  scrollbar-width: thin;
  scrollbar-color: #E3E3E3 transparent;
 
  /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #A5E5C4; 
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #A5E5C4; 
  }

  /* &:hover {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    scrollbar-width: thin;

    @media ${device.tablet} {
      padding-right: 4px;
    }
  } */
`;
